
          import "Text.styles_y68cem.linaria.css";
          import { styled } from "@linaria/react";
import { typeStyle } from "@carvana/showroom-css-theme";
const TextContainer = /*#__PURE__*/styled("div")({
  name: "TextContainer",
  class: "tvi6vkh"
});
const Text = /*#__PURE__*/styled("p")({
  name: "Text",
  class: "tusoj1m"
});
const BodyText = /*#__PURE__*/styled("p")({
  name: "BodyText",
  class: "bedv59h"
});
const LinkText = /*#__PURE__*/styled("a")({
  name: "LinkText",
  class: "l1xwqavc"
});
export { Text, BodyText, LinkText, TextContainer };
          